module.exports = __webpack_public_path__ + "img/review_empty.cf486ca6.png";